"use client";

import { ArrowUpRight, MapPin } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { HoverCard, HoverCardContent, HoverCardTrigger } from "@/components/ui/hover-card";
import { Separator } from "@/components/ui/separator";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ServiceArea() {
  const left = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const right = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const details = [{
    label: "HQ",
    value: "Evermark Industrial"
  }, {
    label: "OPERATIONS",
    value: "Monday to Friday · 9:00 am - 5:00 pm EST"
  }, {
    label: "TELEPHONE",
    value: "407-773-3596"
  }];
  return <section data-section-id="3030" id="service-area" className="bg-background text-foreground relative overflow-hidden py-24 md:py-32 lg:py-44">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="grid grid-cols-1 gap-16 lg:grid-cols-2 lg:gap-20">
          {}
          <div ref={left.ref} className={`flex flex-col justify-center transition-all duration-1000 ease-out ${left.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
            <p className="font-mono text-xs tracking-[0.25em] uppercase mb-10" style={{
            color: "var(--primary)"
          }}>
              — Evermark · Industrial Operations
            </p>

            <h2 className="font-default text-4xl md:text-5xl lg:text-[3.5rem] leading-[1.05] font-bold text-foreground">
              Precision
              <br />
              marking
              <br />
              <span className="italic" style={{
              color: "var(--primary)"
            }}>
                delivered.
              </span>
            </h2>

            <p className="font-default text-xl md:text-2xl mt-10 text-foreground/90 leading-snug">
              267 Live Oaks Blvd
              <br />
              Casselberry, FL 32707
            </p>

            <div className="mt-12 space-y-0">
              {details.map((item, i) => <div data-index={i} key={item.label}>
                  <div className="grid grid-cols-[110px_1fr] gap-6 py-4 items-baseline">
                    <span className="font-mono text-[10px] tracking-[0.2em] uppercase" style={{
                  color: "var(--primary)"
                }}>
                      {item.label}
                    </span>
                    <span className="font-default text-base md:text-lg text-foreground/85">
                      {item.value}
                    </span>
                  </div>
                  {i < details.length - 1 && <Separator className="bg-border/40" />}
                </div>)}
            </div>

            <p className="font-default text-sm mt-10 text-muted-foreground leading-relaxed max-w-md">Evermark processes industrial identification orders. <br />Send your idea or specifications, and we handle the rest.</p>

            <div className="flex flex-col sm:flex-row gap-4 mt-12">
              <Button asChild size="lg" className="font-default text-xs tracking-[0.2em] uppercase h-12 px-8 border bg-accent text-accent-foreground hover:bg-accent/90">
                
              </Button>
              <Button asChild variant="ghost" size="lg" className="font-default text-xs tracking-[0.2em] uppercase h-12 px-2 hover:bg-transparent group" style={{
              color: "var(--primary)"
            }}>
                
              </Button>
            </div>
          </div>

          {}
          <div ref={right.ref} className={`relative transition-all duration-1000 ease-out delay-200 ${right.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
            <div className="relative aspect-[4/5] w-full">
              {}
              <div className="absolute inset-0 translate-x-3 translate-y-3 border pointer-events-none" style={{
              borderColor: "var(--primary)",
              opacity: 0.6
            }} aria-hidden="true" />

              <div className="relative w-full h-full border overflow-hidden" style={{
              borderColor: "var(--border)",
              backgroundColor: "var(--card)"
            }}>
                <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3501.564564564564!2d-81.328!3d28.66!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88e7706666666667%3A0x6666666666666666!2s267%20Live%20Oaks%20Blvd%2C%20Casselberry%2C%20FL%2032707!5e0!3m2!1sen!2sus!4v1710000000000!5m2!1sen!2sus" className="w-full h-full" style={{
                border: 0
              }} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="Evermark Industrial Solutions Location" />
              </div>

              {}
              
            </div>
          </div>
        </div>
      </div>
    </section>;
}